module.exports = __webpack_public_path__ + "static/media/Medical E prescription.191b9936.png";